import * as THREE from "three";
import { useEffect, useRef } from "react";
import { useFrame } from "@react-three/fiber";

function CameraRig({
  look,
  zoomTrigger,
  farZ,
  nearZ,
}: {
  look: { x: number; y: number };
  zoomTrigger: number;
  farZ: number;
  nearZ: number;
}) {
  const zoomHoldUntil = useRef<number>(0);
  const lastCameraLogRef = useRef(0);

  useEffect(() => {
    const now = performance.now();
    zoomHoldUntil.current = now + 1600;
  }, [zoomTrigger]);
  useFrame((state) => {

      const cam = state.camera as THREE.PerspectiveCamera;
      const elapsed = state.clock.getElapsedTime();

      const swayX =
        Math.sin(elapsed * 0.55) * 0.025;

      const swayY =
        Math.cos(elapsed * 0.65) * 0.020;

      const swayZ =
        Math.sin(elapsed * 0.45) * 0.015;

      const scanX =
        Math.sin(elapsed * 0.55) * 0.040;

      const scanY =
        Math.cos(elapsed * 0.50) * 0.030;

        const rawTargetX =
          (look.x * 0.70) + scanX + swayX;

        const targetX =
          THREE.MathUtils.clamp(
            rawTargetX,
            -0.18,
            0.18
          );

      const targetY =
          0.39 + (-look.y * 0.55) + (scanY * 0.25);

      cam.position.x = THREE.MathUtils.lerp(
        cam.position.x,
        targetX,
        0.08
      );

      cam.position.y = THREE.MathUtils.lerp(
        cam.position.y,
        targetY,
        0.08
      );

      const now = performance.now();
      const desiredZ =
        now < zoomHoldUntil.current
          ? nearZ
          : farZ;

      cam.position.z = THREE.MathUtils.lerp(
        cam.position.z,
        (desiredZ + 0.05) + swayZ,
        0.28
      );

      // ============================================
      // AVA CAMERA TARGET PROBE
      // Keeps the camera focused on Ava's head while
      // preserving all existing movement.
      // ============================================

      cam.lookAt(
        0,
        0.58,
        0.20
      );

      if (performance.now() - lastCameraLogRef.current > 1000) {
        lastCameraLogRef.current = performance.now();

      // Production: camera debug removed
}

  });

  return null;
}



export default CameraRig;
